import React, { useLayoutEffect, useRef } from "react";

export default function SidebarTitle({ title }: { title: string }) {
  const clipRef = useRef<HTMLSpanElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);

  useLayoutEffect(() => {
    const clip = clipRef.current;
    const text = textRef.current;
    const row = clip?.closest(".rt-item");
    if (!clip || !text || !row) return;
    const measure = () => {
      const overflow = Math.max(0, text.scrollWidth - clip.clientWidth);
      clip.style.setProperty("--title-offset", `${-overflow}px`);
      // Keep long titles readable at a steady 40 pixels per second.
      clip.style.setProperty("--title-duration", `${overflow / 40}s`);
    };
    measure();
    row.addEventListener("mouseenter", measure);
    row.addEventListener("focusin", measure);
    const observer = typeof ResizeObserver !== "undefined" ? new ResizeObserver(measure) : null;
    observer?.observe(clip);
    observer?.observe(text);
    window.addEventListener("resize", measure);
    return () => {
      observer?.disconnect();
      row.removeEventListener("mouseenter", measure);
      row.removeEventListener("focusin", measure);
      window.removeEventListener("resize", measure);
    };
  }, [title]);

  return (
    <span className="rt-label rt-title-clip" title={title} ref={clipRef}>
      <span className="rt-title-text" ref={textRef}>{title}</span>
    </span>
  );
}
